'use client';

import { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperType } from 'swiper';

import { Autoplay, Navigation, EffectFade } from 'swiper/modules';

import { Content } from '@prismicio/client';
import { Simplify } from '../../../../../prismicio-types';

import styles from './helocHero.module.scss';
import 'swiper/css';
import 'swiper/css/effect-fade';

import Video from './Video/Video';
import TextBlock from './TextBlock/TextBlock';
import { BoxContainer } from '@/components';

const videosWebm = [
  '/static/video/HelocHero/HELOC1.webm',
  '/static/video/HelocHero/HELOC2.webm',
  '/static/video/HelocHero/HELOC3.webm',
  '/static/video/HelocHero/HELOC4.webm',
];

const videos = [
  '/static/video/HelocHero/HELOC1.mp4',
  '/static/video/HelocHero/HELOC2.mp4',
  '/static/video/HelocHero/HELOC3.mp4',
  '/static/video/HelocHero/HELOC4.mp4',
];

const placeholders = [
  '/static/images/HELOC1.webp',
  '/static/images/HELOC2.webp',
  '/static/images/HELOC3.webp',
  '/static/images/HELOC4.webp',
];

interface HelocHeroProps {
  data: Simplify<Content.HeroSliceHelocPrimary>;
}

export const HelocHero = ({ data }: HelocHeroProps) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef<SwiperType | null>(null);

  const goToSlide = (index: number) => {
    if (swiperRef.current) {
      swiperRef.current.slideTo(index);
    }
  };

  return (
    <BoxContainer styles={styles.box_container}>
      <Swiper
        className={styles.swiper}
        rewind
        allowTouchMove={false}
        effect="fade"
        autoplay={{ delay: 5000 }}
        modules={[Autoplay, Navigation, EffectFade]}
        onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
        onInit={(swiper) => {
          swiperRef.current = swiper;
        }}
      >
        {data.titles.map((_slide, index) => (
          <SwiperSlide key={index} className={styles.slide}>
            <Video
              linkWebm={videosWebm[index]}
              link={videos[index]}
              isActive={index === activeIndex}
              placeholder={placeholders[index]}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <TextBlock
        subtitle={data.subtitle}
        button_link={data.button_link}
        button_text={data.button_text}
        titles={data.titles.map((title) => title.title)}
        activeItem={activeIndex}
        onClick={goToSlide}
      />
    </BoxContainer>
  );
};
